import { axiosInstanceV2 } from "./AxiosInstance";

const API_URL = "/mailermetas";
const TEMPLATE_API_URL = "/emailtemplates";
const CONFIG_API_URL = "/emaileventconfigs";
const MAILER_PAGE_CAP = 100;
const MAILER_DEFAULT_LIMIT = 10;

// Mailer Metadata APIs
export const getMailerMetas = async (limit = 10, page = 1, search = "", searchField="") => {
  try {
    let url = `${API_URL}?limit=${limit}&page=${page}`;
    // Add search parameter if provided
    if(searchField){
      url += `&searchField=${searchField}`
    }
    if (search && search.trim() !== "") {
      url += `&search=${encodeURIComponent(search)}`;
    }
    
    const response = await axiosInstanceV2.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching mailer metadata", error);
    throw error;
  }
};

export const addMailerMeta = async (mailerData) => {
  try {
    const response = await axiosInstanceV2.post(API_URL, { 
      ...mailerData, 
      isDeleted: false 
    });
    return response.data;
  } catch (error) {
    console.error("Error adding mailer metadata", error);
    throw error;
  }
};

export const updateMailerMeta = async (mailerData, mailerId) => {
  try {
    const response = await axiosInstanceV2.put(`${API_URL}/${mailerId}`, mailerData);
    return response.data;
  } catch (error) {
    console.error("Error updating mailer metadata", error);
    throw error;
  }
};

export const deleteMailerMeta = async (mailerId) => {
  try {
    const response = await axiosInstanceV2.delete(`${API_URL}/${mailerId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting mailer metadata", error);
    throw error;
  }
};

// Email Template APIs
export const getEmailTemplates = async (limit = 10, page = 1, search = "", searchField = "") => {
  try {
    let url = `${TEMPLATE_API_URL}?limit=${limit}&page=${page}`;
    // Add search parameters if provided
    if (search && search.trim() !== "" && searchField) {
      url += `&search=${encodeURIComponent(search)}&searchField=${searchField}`;
    }
    const response = await axiosInstanceV2.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching email templates", error);
    throw error;
  }
};

export const addEmailTemplate = async (templateData) => {
  try {
    const response = await axiosInstanceV2.post(TEMPLATE_API_URL, { 
      ...templateData, 
      isDeleted: false 
    });
    return response.data;
  } catch (error) {
    console.error("Error adding email template", error);
    throw error;
  }
};

export const updateEmailTemplate = async (templateData, templateId) => {
  try {
    const response = await axiosInstanceV2.put(`${TEMPLATE_API_URL}/${templateId}`, templateData);
    return response.data;
  } catch (error) {
    console.error("Error updating email template", error);
    throw error;
  }
};

export const deleteEmailTemplate = async (templateId) => {
  try {
    const response = await axiosInstanceV2.delete(`${TEMPLATE_API_URL}/${templateId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting email template", error);
    throw error;
  }
};

// Email Event Config APIs
export const getEmailEventConfigs = async (limit = 10, page = 1, search = "", searchField = "", emailtemplateIds) => {
  try {
    let url = `${CONFIG_API_URL}?limit=${limit}&page=${page}`;
    // Add search parameters if provided
    if (search && search.trim() !== "" && searchField) {
      url += `&search=${encodeURIComponent(search)}&searchField=${searchField}`;
    }
    if(emailtemplateIds){
      url += `&searchField=emailtemplateIds&search=${emailtemplateIds}`
    }
    const response = await axiosInstanceV2.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching email event configs", error);
    throw error;
  }
};

export const addEmailEventConfig = async (configData) => {
  try {
    const response = await axiosInstanceV2.post(CONFIG_API_URL, { 
      ...configData, 
      isDeleted: false 
    });
    return response.data;
  } catch (error) {
    console.error("Error adding email event config", error);
    throw error;
  }
};

export const updateEmailEventConfig = async (configData, configId) => {
  try {
    const response = await axiosInstanceV2.put(`${CONFIG_API_URL}/${configId}`, configData);
    return response.data;
  } catch (error) {
    console.error("Error updating email event config", error);
    throw error;
  }
};

export const deleteEmailEventConfig = async (configId) => {
  try {
    const response = await axiosInstanceV2.delete(`${CONFIG_API_URL}/${configId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting email event config", error);
    throw error;
  }
};
